import { useEffect, type RefObject } from "react";
import { OverlayScrollbars } from "overlayscrollbars";
import "overlayscrollbars/styles/overlayscrollbars.css";
import "./CustomScrollbar.scss";

// Draws a styled scrollbar over an element that keeps scrolling natively.
// `host` holds the scrollbar (it must contain and clip `viewport`); `viewport` is the real scroller.
// Give them these attributes so the native scrollbar never shows, even before this runs:
//   host:     data-overlayscrollbars-initialize=""
//   viewport: data-overlayscrollbars-viewport="scrollbarHidden"
export function useCustomScrollbar(hostRef: RefObject<HTMLElement | null>, viewportRef: RefObject<HTMLElement | null>, { alwaysVisible = false }: { alwaysVisible?: boolean } = {}): void {
  useEffect(() => {
    const host = hostRef.current;
    const viewport = viewportRef.current;
    if (!host || !viewport) return;

    const instance = OverlayScrollbars(
      { target: host, elements: { viewport, padding: false, content: false } },
      {
        overflow: { x: "hidden", y: "scroll" },
        scrollbars: { theme: "os-theme-trackvisualizer", autoHide: alwaysVisible ? "never" : "scroll", autoHideDelay: 700, clickScroll: true },
      },
    );

    return () => instance.destroy();
  }, [hostRef, viewportRef, alwaysVisible]);
}
